import { render, staticRenderFns } from "./Dialogue.vue?vue&type=template&id=5b80ae1e&scoped=true&"
import script from "./Dialogue.vue?vue&type=script&lang=js&"
export * from "./Dialogue.vue?vue&type=script&lang=js&"
import style0 from "./Dialogue.vue?vue&type=style&index=0&id=5b80ae1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80ae1e",
  null
  
)

export default component.exports